import React from 'react';
import axios from 'axios';

import { API_PATH_SHARERESULTS_HANZI } from '../constants';



class ShareButton extends React.Component {
	constructor(props) {
		super(props);

		this.state = {hasShared: false};
	}

	shareResults(e) {
    // Copy to clipboard and save the source of the share in the database
    	//const text = 'HSK level '+this.props.userHSKlevel;

    	let text = 'My Chinese characters knowledge statistics'
    	text += '\n\n';
    	text += 'I can understand ' + this.props.userKnownHanzis_meaning + ' characters in Chinese';
    	text += '\n';
    	text += 'I can pronounce ' + this.props.userKnownHanzis_pinyin + ' characters in Chinese';
    	text += '\n';
    	text += 'I can write ' + this.props.userKnownHanzis_handwriting + ' characters in Chinese';
    	text += '\n\n';
    	text += 'Take the test on www.hsklevel.com';

    	navigator.clipboard.writeText(text);

	    axios({
	      method: 'post',
	      url: `${API_PATH_SHARERESULTS_HANZI}`,
	      headers: {'content-type': 'application/json'},
	      data: {userId: this.props.userId}
	    })
	    .then(result => {
		  this.setState({hasShared: true});
		})
	    .catch(error => {});
	}


	render() {  

		return (
		<div>
	        <button className="btn btn-share" style={{margin:'5px 5px 5px 5px', fontSize:'22px'}} type="button"
	        		onClick={(e) => this.shareResults(e)}>
	          Share your results
	        </button>
		    {this.state.hasShared && <p><em>Copied results to clipboard</em></p>}
        </div>
		);
	}
}


export default ShareButton